import { Block } from "@block";
import { useDesktopMediaQuery } from "@media-query";
import { useNavigation } from "@react-navigation/core";
import { StackActions } from "@react-navigation/routers";
import { spacing } from "@styles/spacing";
import { hideModal, showModal } from "app/modules/modal-management/reducer/action";
import HeaderNav from "app/shared/components/header-nav/header-nav";
import GlobalModal, { createGlobalModal, globalModal } from "app/shared/components/modal/global-modal/global-modal";
import { NavTitleBar, SubtitleNavTitleBar } from "app/shared/components/nav-title-bar/nav-title-bar";
import ScreenNameType from "app/shared/constant/nav-screen.type";
import { ITEMLISTSTATEMENT360, ITEMLISTSTATEMENTBACKUP } from "app/shared/services/services-model.type";
import { formatDate } from "app/shared/util/common";
import { formatNumberThousand } from "app/shared/util/format-currency";
import { createWs } from "app/shared/util/xlsx-utils";
import moment from "moment";
import * as React from "react";
import { useTranslation } from "react-i18next";
import Modal from "react-modal";
import { ScrollView } from "react-native";
import { useTheme } from "react-native-paper";
import { useDispatch, useSelector } from "react-redux";
import XLSX from "xlsx";
import {
  fetchStatementBackupRequest,
  fetchStatementDetailRequest,
  fetchStatementV2Request,
  resetStatementBackup,
  setStatement,
} from "../reducer/actions";
import {
  getPendingStatementSelector,
  getResStatementBackupSelector,
  getResStatementV2Selector,
  getStatementSelector,
  getStatusResStatementBackupSelector,
} from "../reducer/selectors";
import { FormFilterStatement } from "../reducer/types";
import DetailTransaction from "./detail-transaction/detail-transaction";
import FilterStatementTable from "./filter-table/filter-statement-table.web";
import StatementTable, { DataStatementV2TableProps } from "./filter-table/statement-table";
import { createDynamicHTMLString } from "./makedata";

export enum ActionFilter {
  Search,
  DownloadExcel,
  DownloadPdf,
  DataTable,
  Reset,
}

const ListStatement = () => {
  const { t } = useTranslation();
  const dispatchStore = useDispatch();
  const { dispatch } = useNavigation();

  const statementStore = useSelector(getStatementSelector);
  const listStatementV2 = useSelector(getResStatementV2Selector);
  const responseStatementBackup = useSelector(getResStatementBackupSelector);
  const statusResponseStatementBackup = useSelector(getStatusResStatementBackupSelector);

  const pending = useSelector(getPendingStatementSelector);

  const [globalModalRef] = React.useState<React.RefObject<any>>(createGlobalModal());
  const [dataStatement, setDataStatement] = React.useState<DataStatementV2TableProps[]>([]);
  const [isShowTable, setShowTable] = React.useState<boolean>(false);
  const [isSearch, setIsSearch] = React.useState<boolean>(false);
  const [dataV2List, setDataV2List] = React.useState<DataStatementV2TableProps[]>([]);
  const [dataFilter, setDataFilter] = React.useState<FormFilterStatement>();

  // Show modal detail 360 transaction
  const [isModalDetailVisible, setModalDetailVisible] = React.useState(false);
  const [itemModalDetail, setItemModalDetailVisible] = React.useState<DataStatementV2TableProps>({});
  const { colors } = useTheme();
  const isDesktop = useDesktopMediaQuery();

  const goHome = () => {
    dispatch(StackActions.replace(ScreenNameType.HOME));
  };

  const goManager = () => {
    dispatch(StackActions.replace(ScreenNameType.LIST_ACCOUNT_MANAGEMENT));
  };

  const subtitlesArrays: Array<SubtitleNavTitleBar> = [
    {
      name: t("FUNC_TRANG_CHU"),
      onPressSubtitle: () => goHome(),
    },
    {
      name: t("ACC_QUAN_LY_TAI_KHOAN"),
      onPressSubtitle: () => goManager(),
    },
    {
      name: t("ACC_SAO_KE_GIAO_DICH"),
      onPressSubtitle: () => {},
    },
  ];

  const exportToCSV = (sheetData: DataStatementV2TableProps[], fileName: any) => {
    const fields = ["id", "FORMAT_TRANS_DATE", "SEQUENNO", "CURRENCY_DEBIT_AMOUNT", "CURRENCY_CREATE_AMOUNT", "CONTENT"];
    const retructionArray = sheetData.map((u: DataStatementV2TableProps) => {
      delete u.ACCFULLNAME;
      delete u.ACCNO;
      delete u.ACCTYPE;
      delete u.BEGINBALANCE;
      delete u.BEGINTRANSBALANCE;
      delete u.BRNCODE;
      delete u.CHANEL;
      delete u.CIFNUMBER;
      delete u.CURRENBALANCE;
      delete u.CURRENCYCODE;
      delete u.ENDBALANCE;
      delete u.ENDBATRANSLANCE;
      delete u.FROMDATE;
      delete u.PRODUCTCODE;
      delete u.RQTSEQ;
      delete u.STT;
      delete u.T24DATE;
      delete u.TODATE;
      delete u.TODATE;
      delete u.CREATEAMOUNT;
      delete u.DEBITAMOUNT;
      delete u.TRANSDATE;
      return u;
    });
    const titles = {
      id: "#",
      FORMAT_TRANS_DATE: t("ACC_NGAY_GIAO_DICH"),
      SEQUENNO: t("ACC_SO_THAM_CHIEU"),
      CURRENCY_DEBIT_AMOUNT: t("ACC_SO_TIEN_GHI_NO") + " (" + t("COMMON_VND") + ")",
      CURRENCY_CREATE_AMOUNT: t("ACC_SO_TIEN_GHI_CO") + " (" + t("COMMON_VND") + ")",
      CONTENT: t("ACC_NOI_DUNG"),
    };
    // Create book new;
    var wb = XLSX.utils.book_new();
    const ws = createWs(retructionArray, fields, titles);

    // Add Row to Sheet
    XLSX.utils.book_append_sheet(wb, ws, "sample");
    XLSX.write(wb, { bookType: "xlsx", type: "binary" });
    XLSX.writeFile(wb, `${fileName}.xlsx`);
  };

  const createPdfFile = React.useCallback(
    (data: ITEMLISTSTATEMENTBACKUP[]) => {
      const html2pdf = require("html2pdf.js");
      const worker = html2pdf();
      worker
        .from(createDynamicHTMLString(data))
        .set({
          margin: [36, 36, 36, 36],
          filename:
            "Sao_Ke_" +
            moment(statementStore.statement?.fromDate, "DD/MM/YYYY").format("DDMMYYYY").toString() +
            "_" +
            moment(statementStore.statement?.toDate, "DD/MM/YYYY").format("DDMMYYYY").toString() +
            ".pdf",
          html2canvas: { dpi: 75, scale: 2, letterRendering: true },
          jsPDF: { unit: "pt", format: "a4", compressPDF: true, orientation: "portrait" },
        })
        .toPdf()
        .get("pdf")
        .then((pdf: any) => {
          var totalPages = pdf.internal.getNumberOfPages();
          for (let i = 1; i <= totalPages; i++) {
            // set footer to every page
            pdf.setPage(i);
            // set footer font
            pdf.addFont(require("@assets/fonts/Montserrat-Regular.ttf"), "Montserrat", "normal");
            pdf.setFontSize(8);
            pdf.setFont("Montserrat", "normal");
            pdf.text("Trang " + i + "/" + totalPages, 36, pdf.internal.pageSize.getHeight() - 24);
            pdf.text(
              pdf.internal.pageSize.getWidth() - 130,
              pdf.internal.pageSize.getHeight() - 24,
              "Ngày in báo cáo: " + moment().format("DD/MM/YYYY").toString(),
            );
          }
        })
        .save();
    },
    [statementStore.statement],
  );

  /**
   * Bắt sự kiện với nút lọc
   * @param type
   * @returns void
   */
  const handleOnChange = (type: ActionFilter) => (_values?: FormFilterStatement) => {
    setDataFilter(_values);
    switch (type) {
      /**
       * Đối với trường hợp Download lấy thông tin từ bảng rồi xuất Excel;
       */
      case ActionFilter.DownloadExcel:
        console.log("DownloadExcel", dataStatement);
        if (dataStatement.length > 0 && _values) {
          console.log("_values: ", _values);
          const fileName =
            "Sao_Ke_" +
            moment(_values.fromDate, "DD/MM/YYYY").format("DDMMYYYY").toString() +
            "_" +
            moment(_values.toDate, "DD/MM/YYYY").format("DDMMYYYY").toString();
          exportToCSV(dataStatement, fileName);
        } else {
          dispatchStore(
            showModal({
              modalProps: {
                open: true,
                message: t("CC_KHONG_CO_GIAO_DICH_NAO"),
              },
              modalType: "alert",
            }),
          );
        }
        break;
      /**
       * Đối với trường hợp Download sổ phụ xuất file PDF;
       */
      case ActionFilter.DownloadPdf:
        console.log("DownloadPdf");
        dispatchStore(fetchStatementBackupRequest(_values));
        break;
      /**
       * Đối với trường hợp Search gắn bình thường
       */
      case ActionFilter.Search:
        if (_values) requestSearch(_values);
        break;
      case ActionFilter.Reset:
        if (isSearch) setIsSearch(false);
        if (isShowTable) setShowTable(false);
        if (listStatementV2?.STATEMENT) dispatchStore(setStatement({ ...statementStore, responseStatementV2: undefined }));
        setDataStatement([]);
        setDataV2List([]);
        break;
      default:
        break;
    }
  };

  const getDateFromTableV2 = React.useCallback((_data: DataStatementV2TableProps[]) => {
    setDataStatement(_data);
  }, []);

  const closeModalInput = () => {
    globalModal.hide(globalModalRef);
  };

  const showModalInput = (content: JSX.Element) => {
    globalModal.show(content, globalModalRef);
  };
  //
  const requestSearch = (data: FormFilterStatement) => {
    dispatchStore(fetchStatementV2Request(data));
  };

  const getDataV2Table = React.useCallback((_data?: ITEMLISTSTATEMENT360[]): Array<DataStatementV2TableProps> => {
    if (_data?.length) {
      _data.map((obj: DataStatementV2TableProps, index: number) => {
        obj.id = String(index + 1);
        obj.CURRENCY_CREATE_AMOUNT = formatNumberThousand(obj.CREATEAMOUNT);
        obj.CURRENCY_DEBIT_AMOUNT = formatNumberThousand(obj.DEBITAMOUNT);
        obj.FORMAT_TRANS_DATE = formatDate(obj.TRANSDATE, "YYYYMMDD");
        return obj;
      });
      return _data;
    }
    return [];
  }, []);

  // Xử lí async đối với trường hợp lấy dữ liệu xuất sổ phụ
  React.useEffect(() => {
    switch (statusResponseStatementBackup) {
      case "error":
        dispatchStore(hideModal());
        dispatchStore(resetStatementBackup());
        break;
      case "ok":
        console.log("Lấy được dữ liệu xử lí xuất sổ phụ !!!");
        dispatchStore(hideModal());
        if (responseStatementBackup?.STATEMENT?.REPORTDETAIL && responseStatementBackup.STATEMENT.REPORTDETAIL.length > 0) {
          createPdfFile(responseStatementBackup?.STATEMENT?.REPORTDETAIL);
          dispatchStore(resetStatementBackup());
        } else {
          dispatchStore(
            showModal({
              modalProps: {
                open: true,
                message: t("COMMON_KHONG_CO_DU_LIEU"),
              },
              modalType: "alert",
            }),
          );
          dispatchStore(resetStatementBackup());
        }
        break;
      case "pending":
        console.log("Trang thai dang pending !!!");
        dispatchStore(
          showModal({
            modalProps: {
              open: true,
            },
            modalType: "loading",
          }),
        );
        break;
      case "init":
        console.log("Tao lai du lieu");
        break;
      default:
        break;
    }
  }, [createPdfFile, dispatch, dispatchStore, responseStatementBackup, statusResponseStatementBackup, t]);

  React.useEffect(() => {
    const dataV2: DataStatementV2TableProps[] = getDataV2Table(listStatementV2?.STATEMENT?.LIST_STATEMENT_360);
    setDataV2List(dataV2);
  }, [getDataV2Table, listStatementV2]);

  React.useEffect(() => {
    if (pending && !isSearch) {
      setIsSearch(true);
    }
  }, [pending, isSearch]);

  React.useEffect(() => {
    if (!pending && isSearch && !isShowTable) {
      setIsSearch(false);
      setShowTable(true);
    }
  }, [pending, isShowTable, isSearch]);

  // Bắt sự kiện khi nhấn vào row trong bảng
  const onPressRowTable = React.useCallback(
    (item: DataStatementV2TableProps) => {
      // alert("Mo modal chi teiet", item.NAME);
      console.log("item", item);
      if (item.SEQUENNO && item.FORMAT_TRANS_DATE) {
        setModalDetailVisible(true);
        setItemModalDetailVisible(item);
        dispatchStore(fetchStatementDetailRequest({ SEQUENCE_NUMBER: item.SEQUENNO, TRANSACTION_DATE: item.FORMAT_TRANS_DATE }));
      }
    },
    [dispatchStore],
  );

  return (
    <Block flex={1}>
      <ScrollView>
        <HeaderNav />
        <NavTitleBar title={t("ACC_SAO_KE_GIAO_DICH")} subtitles={subtitlesArrays} />
        <Block pv={spacing.huge} ph={isDesktop ? spacing.galactic : spacing.huge}>
          <FilterStatementTable
            onChangeDownloadExcel={handleOnChange(ActionFilter.DownloadExcel)}
            onChangeDownloadPdf={handleOnChange(ActionFilter.DownloadPdf)}
            onChangeSearch={handleOnChange(ActionFilter.Search)}
            showModal={showModalInput}
            closeModal={closeModalInput}
            showDownload={dataStatement.length > 0 && isShowTable ? true : false}
            onReset={handleOnChange(ActionFilter.Reset)}
          />
          <StatementTable
            onPressRow={onPressRowTable}
            data={dataV2List}
            onChangeData={getDateFromTableV2}
            isShow={isShowTable}
            dataFilter={dataFilter}
            downloadExcel={handleOnChange(ActionFilter.DownloadExcel)}
            downloadPdf={handleOnChange(ActionFilter.DownloadPdf)}
          />
        </Block>
        <GlobalModal ref={globalModalRef} />
        <Modal
          style={{
            overlay: {
              zIndex: 9999,
              position: "fixed",
              backgroundColor: colors.backdrop,
            },
            content: {
              border: "0",
              borderRadius: "24px",
              bottom: "auto",
              minHeight: "10rem",
              left: "50%",
              position: "fixed",
              right: "auto",
              top: "50%",
              transform: "translate(-50%,-50%)",
              minWidth: "20rem",
              width: "80%",
              maxWidth: "100rem",
            },
          }}
          contentLabel="Modal"
          ariaHideApp={false}
          onRequestClose={() => setModalDetailVisible(false)}
          children={
            <DetailTransaction
              param={itemModalDetail}
              onCloseModal={() => {
                setModalDetailVisible(false);
              }}
            />
          }
          isOpen={isModalDetailVisible}
        />
      </ScrollView>
    </Block>
  );
};

export default ListStatement;
